<template>
  <div class="gridtask">
    <!-- 位置展示 start -->
    <!-- <div class="mianbao">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>网格工作</el-breadcrumb-item>
                <el-breadcrumb-item>综合网格</el-breadcrumb-item>
                <el-breadcrumb-item>网格任务</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
    <!-- 位置展示 end -->

    <!-- 展示区域 start -->
    <div class="top">
      <!-- 查询 start -->
      <div class="fisthang">
        <el-form
          :inline="true"
          :model="searchlist"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item label="任务名称:">
            <el-input
              v-model="searchlist.taskName"
              placeholder="请输入任务名称"
              style="width: 120px"
            ></el-input>
          </el-form-item>
          <el-form-item label="完成时间:">
            <el-date-picker
              class="completeTime"
              v-model="searchlist.completeTime"
              value-format="yyyy-MM-dd"
              size="mini"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item v-if="orgLevel == 2" label="发布人员:">
            <el-input
              class="createPersonName"
              v-model="searchlist.createPersonName"
              placeholder="请输入发布人员名称"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="orgLevel == 4" label="上报状态:">
            <el-select
              v-model="searchlist.reportFlag"
              placeholder="请选择上报状态"
            >
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务大类">
            <el-select
              class="bigType"
              @change="onSearchBigTypeChange"
              v-model="searchlist.bigType"
              placeholder="请选择大类"
            >
              <el-option
                v-for="item in searchBigTaskCategory"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务小类">
            <el-select
              class="smallType"
              @change="onSearchSmallTypeChange"
              v-model="searchlist.smallType"
              placeholder="请选择小类"
            >
              <el-option
                v-for="item in searchSamllTaskCategory"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchlistdata('gridTask')"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button type="info" @click="searchlistReset('gridTask')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 查询 end -->

      <!-- 新增按钮 start -->
      <el-button
        type="primary"
        v-permission="{ sign: 'wgrw:wgrwlb:add' }"
        class="button"
        size="mini"
        @click="showa()"
        >新增</el-button
      >
      <!-- 新增按钮 end -->

      <!-- 任务列表 start -->
      <el-table
        :data="tableData"
        border
        align="center"
        style="width: 100%"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="index" align="center" label="序号" width="50">
        </el-table-column>
        <el-table-column
          prop="taskName"
          align="center"
          label="任务名称"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="smallTypeName"
          align="center"
          label="任务小类"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="createDate"
          align="center"
          label="发布时间"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="createPersonName"
          align="center"
          label="发布人员"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="completeTime"
          align="center"
          label="完成时间"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          v-if="orgLevel != 4"
          prop="namelist"
          align="center"
          label="接收人员"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="content"
          align="center"
          :show-overflow-tooltip="true"
          label="内容"
        >
        </el-table-column>
        <el-table-column
          v-if="orgLevel == 4"
          prop="reportFlag"
          align="center"
          label="上报状态"
        >
        </el-table-column>
        <el-table-column
          v-if="orgLevel != 4"
          prop="taskProgress"
          align="center"
          label="任务进度"
        >
        </el-table-column>
        <!-- <el-table-column
                    prop="auditFlag"
                    align="center"
                    label="审核状态">
                </el-table-column> -->
        <el-table-column prop="auditFlag" align="center" label="审核状态">
        </el-table-column>
        <el-table-column prop="auditPersonName" align="center" label="审核人员">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              v-if="scope.row.isshow && scope.row.auditButtonFlag == 1"
              content="审核"
              placement="top-start"
            >
              <button
                style="color: skyblue"
                class="iconfont icon-shenhe tabBtn"
                @click="look(scope.row, '审核')"
                v-permission="{ sign: 'wgrw:wgrwlb:audit' }"
              ></button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              v-if="
                (scope.row.auditFlag != '通过' && id == scope.row.createId) ||
                (id == scope.row.auditPersonId && scope.row.auditFlag != '通过')
              "
              content="修改"
              placement="top-start"
            >
              <!-- <button
                            style="color:skyblue"
                            class="iconfont icon-bianji3 tabBtn"
                            @click="changedata(scope.row)"
                            v-permission="{sign:'wgrw:wgrwlb:update'}"
                        ></button> -->
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="查看"
              placement="top-start"
            >
              <button
                style="color: skyblue"
                class="iconfont icon-chakan tabBtn"
                @click="look(scope.row, '查看')"
              ></button>
            </el-tooltip>
            <!-- <el-tooltip class="item" effect="dark" content="删除"
                        v-show='orgLevel == 2 || (scope.row.auditFlag == "通过" && id == scope.row.createId) || (id == scope.row.auditPersonId && scope.row.auditFlag == "通过") ' placement="top-start">
                         <button
                            style="color:skyblue"
                            class="iconfont icon-icon7 tabBtn"
                            @click="deletepanduan(scope.row)"
                            v-permission="{sign:'wgrw:wgrwlb:delete'}"
                        ></button>
                        </el-tooltip> -->
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              v-show="
                id == scope.row.createId ||
                (scope.row.auditFlag == '通过' && id == scope.row.createId) ||
                (id == scope.row.auditPersonId && scope.row.auditFlag == '通过')
              "
              placement="top-start"
            >
              <button
                style="color: skyblue"
                class="iconfont icon-icon7 tabBtn"
                @click="deletepanduan(scope.row)"
                v-permission="{ sign: 'wgrw:wgrwlb:delete' }"
              ></button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              v-show="scope.row.isshow == 0 && orgLevel == 4"
              content="网格员上报"
              placement="top-start"
            >
              <button
                style="color: skyblue"
                class="iconfont icon-shijianshangbao tabBtn"
                @click="report(scope.row)"
                v-permission="{ sign: 'wgrw:wgrwlb:report' }"
              ></button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="社区上报"
              v-if="scope.row.isshow == 0 && orgLevel == 3"
              placement="top-start"
            >
              <button
                style="color: skyblue"
                class="iconfont icon-shijianshangbao tabBtn"
                @click="shequreport(scope.row)"
              ></button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              v-if="scope.row.auditFlag == '通过'"
              content="查看网格员上报"
              placement="top-start"
            >
              <button
                style="color: skyblue"
                class="iconfont icon-liulan tabBtn"
                @click="myupload(scope.row)"
                v-permission="{ sign: 'wgrw:wgrwlb:ckwgysb' }"
              ></button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              v-if="scope.row.auditFlag == '通过'"
              content="查看社区上报"
              placement="top-start"
            >
              <button
                style="color: skyblue"
                class="iconfont icon-liulan tabBtn"
                @click="cksqsb(scope.row)"
                v-permission="{ sign: 'wgrw:wgrwlb:cksqsb' }"
              ></button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="催办"
              v-if="
                (scope.row.auditFlag == '通过' && id == scope.row.createId) ||
                (id == scope.row.auditPersonId && scope.row.auditFlag == '通过')
              "
              placement="top-start"
            >
              <button
                style="color: skyblue"
                class="iconfont icon-tongzhi tabBtn"
                @click="rushShow(scope.row)"
                v-permission="{ sign: 'wgrw:wgrwlb:ckwgysb' }"
              ></button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 任务列表 end -->

      <!-- 分页 start -->
      <el-pagination
        :page-size="pageConfig.pageSize"
        layout="total, prev, pager, next, jumper"
        @current-change="handleCurrentChange($event, 'gridTask')"
        :total="pageConfig.total"
      ></el-pagination>
      <!-- 分页 end -->

      <!-- 新增模态框 start -->
      <el-dialog
        title="新增"
        class="dialog"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :before-close="offonNew"
        width="50%"
      >
        <div class="add">
          <span>任务名称:</span>
          <div class="zujian">
            <el-input
              v-model="add.taskName"
              placeholder="请输入任务名称"
            ></el-input>
          </div>
        </div>
        <div class="add">
          <span>任务类别:</span>
          <div class="zujian task-category">
            <el-select
              class="task-category-left"
              @change="onBigTypeChange"
              v-model="bigType"
              placeholder="请选择大类"
            >
              <el-option
                v-for="item in bigTaskCategory"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              class="task-category-right"
              v-model="smallType"
              placeholder="请选择小类"
            >
              <el-option
                v-for="item in samllTaskCategory"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="add">
          <span>选择部门:</span>
          <div class="zujian">
            <el-cascader
              :show-all-levels="false"
              :props="{ multiple: true, checkStrictly: true }"
              ref="receivePerson"
              v-model="receivePerson"
              :options="orgData"
              @change="handleChange"
            ></el-cascader>
          </div>
        </div>

        <div class="add">
          <span>接收人员:</span>
          <div class="zujian">
            <el-cascader
              v-model="value"
              @change="receiveChange"
              :options="userlist"
            >
            </el-cascader>
          </div>
        </div>

        <div class="add">
          <span>已选接收人员:</span>
          <div class="zujian jieshou">
            <div
              class="yixuan"
              v-for="(item, index) in add.receivePersonList"
              :key="index"
            >
              <span>{{ item.label }}</span>
              <i class="iconfont icon-chahao" @click="deleteReceive(item)"></i>
            </div>
          </div>
        </div>

        <div class="add">
          <span>审核人员:</span>
          <el-select v-model="add.auditPersonId" placeholder="请选择职位">
            <el-option
              v-for="(item, index) in reviewerlist"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="add">
          <span>指派内容:</span>
          <div class="zujian">
            <!-- <Editor1></Editor1> -->
            <el-input
              v-model="text1"
              :autosize="{ minRows: 4 }"
              type="textarea"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
        <div class="add">
          <span>完成时间:</span>
          <div class="zujian">
            <el-date-picker
              class="gridTimeSelector"
              v-model="add.completeTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择完成时间"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="add">
          <span class="position">上传附件:</span>
          <span></span>
          <div class="zujian">
            <el-upload
              class="upload-demo"
              :action="url"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="fileok"
              multiple
              :limit="9"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="primary" class="gridClickButton"
                >点击上传</el-button
              >
            </el-upload>
          </div>
        </div>
        <div class="add">
          <span>上传图片:</span>
          <div class="zujian width">
            <el-upload
              :action="url"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview2"
              :on-success="imgok"
              :file-list="fileListimg"
              :on-remove="handleRemove2"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible1">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </div>
        </div>
        <div class="bottombutton">
          <el-button type="primary" size="mini" @click="send()">保存</el-button>
          <el-button type="info" size="mini" @click="offondialog()"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 新增模态框 end -->

      <!-- 修改模态框 start -->
      <el-dialog
        title="修改"
        class="dialog"
        :visible.sync="changeOperation"
        :append-to-body="true"
        :before-close="offonChange"
        width="50%"
      >
        <div class="add">
          <span>任务名称:</span>
          <div class="zujian">
            <el-input
              v-model="add.taskName"
              placeholder="请输入任务名称"
            ></el-input>
          </div>
        </div>

        <div class="add">
          <span>选择部门:</span>
          <div class="zujian">
            <el-cascader
              :show-all-levels="false"
              v-model="receivePerson"
              :options="orgData"
              :props="{ multiple: true }"
              @change="handleChange"
            ></el-cascader>
          </div>
        </div>

        <div class="add">
          <span>接收人员:</span>
          <div class="zujian">
            <el-cascader
              v-model="value"
              @change="receiveChange"
              :options="userlist"
            >
            </el-cascader>
          </div>
        </div>

        <div class="add">
          <span>已选接收人员:</span>
          <div class="zujian jieshou">
            <div
              class="yixuan"
              v-for="(item, index) in add.receivePersonList"
              :key="index"
            >
              <span>{{ item.label }}</span>
              <i class="iconfont icon-chahao" @click="deleteReceive(item)"></i>
            </div>
          </div>
        </div>

        <div class="add">
          <span>指派内容:</span>
          <div class="zujian">
            <!-- <Editor1></Editor1> -->
            <el-input
              v-model="text1"
              type="textarea"
              :autosize="{ minRows: 4 }"
              placeholder="请输入修改内容"
            ></el-input>
          </div>
        </div>
        <div class="add">
          <span>审核人员:</span>
          <el-select v-model="add.auditPersonId" placeholder="请选择职位">
            <el-option
              v-for="(item, index) in reviewerlist"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="add">
          <span>完成时间:</span>
          <div class="zujian">
            <el-date-picker
              v-model="add.completeTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择完成时间"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="add">
          <span class="position">上传附件:</span>
          <span></span>
          <div class="zujian">
            <el-upload
              class="upload-demo"
              :action="url"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="fileok"
              :on-preview="handlePreview"
              multiple
              :limit="9"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
        </div>
        <div class="add">
          <span>上传图片:</span>
          <div class="zujian width">
            <el-upload
              :action="url"
              list-type="picture-card"
              :file-list="fileListimg"
              :on-preview="handlePictureCardPreview2"
              :on-success="imgok"
              :on-remove="handleRemove2"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible1">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </div>
        </div>
        <div class="bottombutton">
          <el-button type="primary" size="mini" @click="changesend()"
            >保存</el-button
          >
          <el-button
            type="info"
            size="mini"
            @click="offondialog('changeOperation')"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改模态框 end -->

      <!-- 查看和审核模态框 start -->
      <el-dialog
        :title="lookTitle"
        class="dialog"
        :visible.sync="lookOperation"
        :append-to-body="true"
        :before-close="offonLook"
        width="50%"
      >
        <div class="add">
          <span>任务名称:</span>
          <el-input class="zujian" v-model="add.taskName" :disabled="true">
          </el-input>
        </div>
        <div class="add">
          <span>指派内容:</span>
          <el-input
            class="zujian"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="add.content"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="add">
          <span>完成时间:</span>
          <el-input class="zujian" v-model="add.completeTime" :disabled="true">
          </el-input>
        </div>
        <div class="add">
          <span>接收人员:</span>
          <div class="zujian">
            <el-input class="zujian" v-model="add.namelist" :disabled="true">
            </el-input>
          </div>
        </div>
        <div class="add">
          <span>审核人员:</span>
          <el-input
            class="zujian"
            v-model="add.auditPersonName"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="add">
          <span>审核状态:</span>
          <el-input class="zujian" v-model="add.auditFlag" :disabled="true">
          </el-input>
        </div>

        <div class="add" v-if="add.auditFlag == '不通过'">
          <span>审核建议:</span>
          <el-input class="zujian" v-model="add.failureReason" :disabled="true">
          </el-input>
        </div>

        <div class="add">
          <span class="position">附件:</span>
          <span></span>
          <div class="zujian">
            <a
              v-for="(item, index) in myfilelist"
              :key="index"
              :href="item.url"
              style="margin-top: 10px"
              target="_blank"
              class="auto"
              rel="noopener noreferrer"
              >{{ item.name }}</a
            >
          </div>
        </div>
        <div class="add">
          <span class="position">图片:</span>
          <span></span>
          <div class="zujian width">
            <img
              v-for="(item, index) in add.photo"
              class="lookimg"
              :key="index"
              :src="item"
              @click="show(item)"
              alt=""
            />
          </div>
        </div>
        <div class="add" v-if="isaudit">
          <span>审核意见:</span>
          <div class="zujian">
            <!-- <Editor1></Editor1> -->
            <el-input
              v-model="AuditOpinion"
              :autosize="{ minRows: 4 }"
              type="textarea"
              placeholder="审核不通过时,请填写此项"
            ></el-input>
          </div>
        </div>
        <div class="bottombutton" v-if="isaudit">
          <el-button
            type="primary"
            size="mini"
            @click="audit(2)"
            :disabled="isClick == true"
            >审核通过</el-button
          >
          <el-button type="info" size="mini" @click="audit(0)"
            >审核不通过</el-button
          >
        </div>
        <!-- 页面分割线 ====================================== -->
        <div class="add" v-if="orgLevel == 4 && lookshow">
          <span>上报内容:</span>
          <el-input
            class="zujian"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="add.gridContent"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="add" v-if="orgLevel == 4 && lookshow">
          <span>上报附件:</span>
          <div class="zujian">
            <a
              v-for="(item, index) in add.gridEnclosure"
              :key="index"
              :href="item.url"
              style="margin-top: 10px"
              target="_blank"
              class="auto"
              rel="noopener noreferrer"
              >{{ item.name }}</a
            >
          </div>
        </div>
        <div class="add" v-if="orgLevel == 4 && lookshow">
          <span class="position">上报图片:</span>
          <span></span>
          <div class="zujian width">
            <img
              v-for="(item, index) in add.gridPhoto"
              class="lookimg"
              :key="index"
              :src="item"
              @click="show(item)"
              alt=""
            />
          </div>
        </div>
      </el-dialog>
      <!-- 查看和审核模态框 end -->

      <!-- 网格员上报 start -->
      <el-dialog
        title="网格员上报"
        class="dialog"
        :visible.sync="lookReport"
        :append-to-body="true"
        :before-close="hideReport"
        width="50%"
      >
        <div class="add">
          <span>上报内容:</span>
          <div class="zujian">
            <!-- <Editor1></Editor1> -->
            <el-input
              v-model="text1"
              type="textarea"
              placeholder="请输入修改内容"
            ></el-input>
          </div>
        </div>
        <div class="add">
          <span class="position">上传附件:</span>
          <span></span>
          <div class="zujian">
            <el-upload
              class="upload-demo"
              :action="url"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="fileok"
              multiple
              :limit="9"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
        </div>
        <div class="add">
          <span class="position">上传图片:</span>
          <span></span>
          <div class="zujian width">
            <el-upload
              :action="url"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview2"
              :on-success="imgok"
              :file-list="fileListimg"
              :on-remove="handleRemove2"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible1">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </div>
        </div>
        <div class="bottombutton">
          <el-button type="primary" size="mini" @click="reportSend(1)"
            >保存并上报</el-button
          >
          <el-button type="primary" size="mini" @click="reportSend(3)"
            >保存</el-button
          >
          <el-button type="info" size="mini" @click="hideReport()"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 网格员上报 end -->

      <!-- 社区上报 start -->
      <el-dialog
        title="社区上报"
        class="dialog"
        :visible.sync="shequlookReport"
        :append-to-body="true"
        :before-close="shequhideReport"
        width="50%"
      >
        <div class="add">
          <span>上报内容:</span>
          <div class="zujian">
            <!-- <Editor1></Editor1> -->
            <el-input
              v-model="text1"
              type="textarea"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
        <div class="add">
          <span class="position">上传附件:</span>
          <span></span>
          <div class="zujian">
            <el-upload
              class="upload-demo"
              :action="url"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="fileok"
              multiple
              :limit="9"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
        </div>
        <div class="add">
          <span class="position">上传图片:</span>
          <span></span>
          <div class="zujian width">
            <el-upload
              :action="url"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview2"
              :on-success="imgok"
              :file-list="fileListimg"
              :on-remove="handleRemove2"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible1">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </div>
        </div>
        <div class="bottombutton">
          <el-button type="primary" size="mini" @click="shequreportSend(1)"
            >保存并上报</el-button
          >
          <el-button type="primary" size="mini" @click="shequreportSend(3)"
            >保存</el-button
          >
          <el-button type="info" size="mini" @click="shequhideReport()"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 社区上报 end -->

      <!-- 查看上报 start -->
      <el-dialog
        title="上报列表"
        class="dialog"
        :visible.sync="lookupload"
        :append-to-body="true"
        :before-close="hideupload"
        width="80%"
      >
        <el-table :data="add" border align="center" style="width: 100%">
          <el-table-column prop="id" label="序号" align="center" width="180">
          </el-table-column>
          <el-table-column prop="gridManName" align="center" label="网格员">
          </el-table-column>
          <el-table-column prop="reportTime" align="center" label="上报时间">
          </el-table-column>
          <el-table-column
            prop="gridContent"
            align="center"
            :show-overflow-tooltip="true"
            label="内容"
          >
          </el-table-column>
          <el-table-column prop="reportFlag" align="center" label="上报状态">
          </el-table-column>
          <el-table-column prop="readFlag" align="center" label="APP状态">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="查看"
                placement="top-start"
              >
                <button
                  style="color: skyblue"
                  class="iconfont icon-chakan tabBtn"
                  @click="xiangxi(scope.row)"
                ></button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 查看上报 end -->

      <!-- 查看社区上报 start -->
      <el-dialog
        title="社区上报列表"
        class="dialog"
        :visible.sync="cksqsbshow"
        :append-to-body="true"
        :before-close="cksqsbhide"
        width="80%"
      >
        <el-table :data="add" border align="center" style="width: 100%">
          <el-table-column prop="id" label="序号" align="center" width="180">
          </el-table-column>
          <el-table-column
            prop="communityManName"
            align="center"
            label="上报人员"
          >
          </el-table-column>
          <el-table-column
            prop="communityReportTime"
            align="center"
            label="上报时间"
          >
          </el-table-column>
          <el-table-column
            prop="communityContent"
            align="center"
            :show-overflow-tooltip="true"
            label="内容"
          >
          </el-table-column>
          <el-table-column
            prop="communityReportFlag"
            align="center"
            label="上报状态"
          >
          </el-table-column>
          <!-- <el-table-column
                        prop="readFlag"
                        align="center"
                        label="消息状态">
                    </el-table-column> -->
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="查看"
                placement="top-start"
              >
                <button
                  style="color: skyblue"
                  class="iconfont icon-chakan tabBtn"
                  @click="sqxiangxi(scope.row)"
                ></button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 查看社区上报 end -->

      <!-- 社区上报详细 start -->
      <el-dialog
        title="查看"
        class="dialog"
        :visible.sync="sqxi"
        :append-to-body="true"
        :before-close="hidesqxiangxi"
        width="50%"
      >
        <div class="add">
          <span>上报内容:</span>
          <el-input
            class="zujian"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="add.communityContent"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="add">
          <span class="position">上报附件:</span>
          <span></span>
          <div class="zujian">
            <a
              v-for="(item, index) in add.communityEnclosure"
              :key="index"
              :href="item.url"
              style="margin-top: 10px"
              target="_blank"
              class="auto"
              rel="noopener noreferrer"
              >{{ item.name }}</a
            >
          </div>
        </div>
        <div class="add">
          <span class="position">上报图片:</span>
          <span></span>
          <div class="zujian width">
            <img
              v-for="(item, index) in add.communityPhoto"
              class="lookimg"
              :key="index"
              :src="item"
              @click="show(item)"
              alt=""
            />
          </div>
        </div>
      </el-dialog>
      <!-- 社区上报详细 end -->

      <!-- 网格员上报详细 start -->
      <el-dialog
        title="查看"
        class="dialog"
        :visible.sync="lookxiangqing"
        :append-to-body="true"
        :before-close="hidexiangxi"
        width="50%"
      >
        <div class="add">
          <span>上报内容:</span>
          <el-input
            class="zujian"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="add.gridContent"
            :disabled="true"
          >
          </el-input>
        </div>
        <div class="add">
          <span class="position">上报附件:</span>
          <span></span>
          <div class="zujian">
            <a
              v-for="(item, index) in add.gridEnclosure"
              :key="index"
              :href="item.url"
              style="margin-top: 10px"
              target="_blank"
              class="auto"
              rel="noopener noreferrer"
              >{{ item.name }}</a
            >
          </div>
        </div>
        <div class="add">
          <span class="position">上报图片:</span>
          <span></span>
          <div class="zujian width">
            <img
              v-for="(item, index) in add.gridPhoto"
              class="lookimg"
              :key="index"
              :src="item"
              @click="show(item)"
              alt=""
            />
          </div>
        </div>
      </el-dialog>
      <!-- 网格员上报详细 end -->

      <!-- 催办 start -->
      <el-dialog
        title="操作"
        class="dialog"
        :visible.sync="urgedDialog"
        :append-to-body="true"
        :before-close="rushHide"
        width="60%"
      >
        <div class="cboffon">
          <p
            :class="{ show: cbshow, hide: !cbshow }"
            @click="
              cbshow = true
              cblistshow = true
            "
          >
            催办
          </p>
          <p
            :class="{ show: !cbshow, hide: cbshow }"
            @click="
              cbshow = false
              cblistshow = false
            "
          >
            记录
          </p>
        </div>
        <!-- 催办记录 start -->
        <div style="margin-bottom: 20px" v-show="!cblistshow">
          <!-- 记录列表 start -->
          <el-table :data="cuiRecord" border align="center" style="width: 100%">
            <el-table-column
              prop="createPersonName"
              align="center"
              label="发布人"
            >
            </el-table-column>
            <el-table-column prop="urgeDate" align="center" label="催办时间">
            </el-table-column>
            <el-table-column prop="urgeType" align="center" label="催办方式">
            </el-table-column>
            <el-table-column
              prop="urgeContent"
              align="center"
              :show-overflow-tooltip="true"
              label="催办内容"
              width="280"
            >
            </el-table-column>
            <el-table-column
              prop="urgePerson"
              align="center"
              label="催办人员"
              width="280"
            >
            </el-table-column>
          </el-table>
          <!-- 记录列表 end -->

          <!-- 分页 start -->
          <el-pagination
            style="margin-top: 10px"
            :page-size="mypageConfig.pageSize"
            layout="total, prev, pager, next, jumper"
            @current-change="changepageSize($event)"
            :total="mypageConfig.total"
          ></el-pagination>
          <!-- 分页 end -->
        </div>
        <!-- 催办记录 end -->

        <!-- 可催办列表 start -->
        <div v-show="cblistshow">
          <!-- 催办人列表 start -->
          <div style="max-height: 400px; overflow: auto">
            <el-table
              :data="mycbdata"
              border
              align="center"
              @selection-change="changechecked"
              style="width: 100%"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="id" align="center" label="序号">
              </el-table-column>
              <el-table-column prop="orgName" align="center" label="所属网格">
              </el-table-column>
              <el-table-column prop="gridManName" align="center" label="网格员">
              </el-table-column>
              <el-table-column prop="mobile" align="center" label="手机号码">
              </el-table-column>
              <el-table-column prop="reportFlag" align="center" label="状态">
              </el-table-column>
            </el-table>
          </div>
          <!-- 催办人列表 end -->

          <!-- 催办内容 start -->
          <div class="add">
            <span>催办内容:</span>
            <div class="zujian">
              <el-input
                v-model="cuiban.cbtextarea"
                type="textarea"
                :autosize="{ minRows: 4 }"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>
          <!-- 催办内容 end -->

          <!-- 催办方式 start -->
          <div class="add">
            <span>催办方式:</span>
            <div class="zujian">
              <el-checkbox-group v-model="cuiban.cbfangshi">
                <el-checkbox
                  v-for="item in cbfangshilist"
                  :label="item"
                  :key="item"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <!-- 催办方式 end -->

          <!-- 操作 start -->
          <div class="bottombutton">
            <el-button type="primary" size="mini" @click="cbsend()"
              >确定</el-button
            >
            <el-button type="info" size="mini" @click="rushHide()"
              >取消</el-button
            >
          </div>
          <!-- 操作 end -->
        </div>
        <!-- 可催办列表 end -->
      </el-dialog>
      <!-- 催办 end -->

      <!-- 查看大图 start -->
      <div v-if="showImg" @click="showImg = false" class="bigbox">
        <img :src="showImgUrl" class="bigImg" alt="" />
      </div>
      <!-- 查看大图 end -->
    </div>
    <!-- 展示区域 end -->
  </div>
</template>

<script>
// import Editor1 from '@/component/Editor1'
import { post, get } from "@/api/requrestHttp.js"
import { tabdata } from "@/mixins/tabledataMix.js"
import baseURL from "@/api/baseURL"
export default {
  data() {
    return {
      isClick: false,
      url: baseURL + `/ypt/controller/uploadVotePic/info/uploadPartyPhoto`,
      // url:'http://121.40.26.248:9001/qianmi-wisdom-zhsq-web-api/controller/uploadVotePic/info/uploadPartyPhoto', //本地
      // url:'http://112.30.214.240:9080/qianmi-wisdom-zhsq-web-api/controller/uploadVotePic/info/uploadPartyPhoto', //池州
      id: "", //用户id判断显示按钮
      text1: "", //接收富文本传过来的值
      value: "",
      cbtaskid: "", //催办id
      orgLevel: "", //用户的等级
      showImgUrl: "", //大图的地址
      AuditOpinion: "", //审核意见
      lookTitle: "查看", //查看和审核模态框标题
      receivePerson: "", //接收部门
      dialogImageUrl: "", //图片上传
      dou: true, //函数防抖
      sqxi: false, //社区详情
      cbshow: true, //催办/记录 开关
      taskId: null, //taskId
      showImg: false, //大图是否显示
      isaudit: false, //审核界面是否显示审核按钮
      lookshow: false,
      lookupload: false, // 查看上报模态框
      lookReport: false, // 网格员上报界面
      cblistshow: true, //催办切换
      cksqsbshow: false, //查看社区上报
      urgedDialog: false, //催办界面
      lookxiangqing: false, //详细页面
      lookOperation: false, // 查看和审核模态框
      dialogVisible: false, // 模态框按钮
      dialogVisible1: false, // 上传模态框按钮
      changeOperation: false, // 修改模态框
      shequlookReport: false, //社区
      orgData: [], //接收组织
      cbcklist: [], //
      mycbdata: [], //催办数据列表
      userlist: [], // 指派人员列表
      fileList: [], //附件上传列表
      cuiRecord: [], //催办记录列表
      myfilelist: [], //我的文件列表
      fileListimg: [], //图片上传列表
      reviewerlist: [], // 可选审核人列表
      cbfangshilist: ["短信", "App"], //催办人列表
      status: [
        {
          value: 1,
          label: "已上报",
        },
        {
          value: 0,
          label: "未上报",
        },
      ], //搜索上报状态
      cuiban: {
        cbtextarea: "", //催办内容
        cbchecked: [], //催办勾选列表
        cbfangshi: [], //催办方式
      }, //催办
      mypageConfig: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      }, //催办记录列表分页
      add: {
        taskName: "", //任务名称
        completeTime: "", //完成时间
        receivePersonList: [], //接收人员
        auditPersonId: "", //审核人员
        content: "", //指派内容
        enclosure: [], //附件后台返回的地址
        photo: [], //图片后台返回的地址
      }, //新增按钮内容
      // 新增界面的任务类别
      bigTaskCategory: [
        { label: "综合协调", value: 1 },
        { label: "社会治理", value: 2 },
        { label: "社会事务", value: 3 },
        { label: "城市管理", value: 4 },
      ],
      searchBigTaskCategory: [
        { label: "综合协调", value: 1 },
        { label: "社会治理", value: 2 },
        { label: "社会事务", value: 3 },
        { label: "城市管理", value: 4 },
      ],
      searchSamllTaskCategory: [],
      samllTaskCategory: [],
      bigType: "", // 任务类别大类
      smallType: "", // 任务类别子类
    }
  },
  // components:{
  //     Editor1  //富文本组件
  // },
  mixins: [tabdata],
  mounted() {
    this.orgLevel = this.$store.state.orgLevel
    this.id = this.$store.state.id
    //监听富文本页面(Editor1)发来的数据
    // this.$Bus.$on('change',(e)=>{
    //     this.text1 = e.text
    // })
    // this.init()
  },
  methods: {
    //初始化页面数据
    init: async function () {
      this.tableDataUrl = "/admin/gridTask/info/list"
      this.getPageDatas("", "gridTask")
      this.getReviewerList()
      let result = await post("/rbac/admin/org/info/OrgTreelist", {
        orgType: 1,
        isValid: 1,
      })
      this.orgData = result.content
    },
    //显示催办
    rushShow: async function (data) {
      this.urgedDialog = true
      //获取催办人员信息
      let result = await this.$post("/admin/gridTask/info/urgePersonList", {
        taskId: data.id,
      })
      if (result.content != null && result.content != undefined) {
        result.content.map((item, index) => {
          this.cbcklist.push(false)
          item.reportFlag = "未上报"
        })
      }
      this.mycbdata = result.content
      this.cbtaskid = data.id
      this.getCbList()
    },
    //获取催办记录别表
    getCbList: async function () {
      const { pageSize, pageNo } = this.mypageConfig
      let result = await this.$post("/admin/gridTaskUrge/info/list", {
        pageSize,
        pageNo,
        taskId: this.cbtaskid,
      })
      if (result.code == 200) {
        this.mypageConfig.total = result.content.count
        if (result.content.list != null && result.content.list != undefined) {
          this.cuiRecord = result.content.list
        }
      }
      console.log(result)
    },
    //隐藏催办
    rushHide: function (data) {
      this.urgedDialog = false
      this.cblistshow = true
      this.cbshow = true
      this.cbcklist = []
      this.cuiban = {
        cbtextarea: "",
        cbchecked: [],
        cbfangshi: [],
      }
      this.mypageConfi = {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      }
    },
    //催办选择
    changechecked: function (data) {
      this.cuiban.cbchecked = data
    },
    //催办发送
    cbsend: async function () {
      let urgeType = ""
      this.cuiban.cbfangshi.map((item, index) => {
        urgeType += item == "App" ? 1 + "," : 2 + ","
      })

      let urgePerson = ""
      this.cuiban.cbchecked.map((item, index) => {
        urgePerson += item.gridManId + ","
      })

      let result = await this.$post("/admin/gridTaskUrge/info/insert", {
        urgeType,
        urgeContent: this.cuiban.cbtextarea,
        urgePerson,
        taskId: this.cbtaskid,
      })
      this.showMsg(result.code, "通知成功", "通知失败")
      if (result.code == 200) {
        this.rushHide()
      }
    },
    //显示大图
    show: function (url) {
      this.showImg = true
      this.showImgUrl = url
    },
    //显示上报详情
    xiangxi: function (data) {
      let arr = []
      if (data.gridEnclosure != null && data.gridEnclosure != undefined) {
        data.gridEnclosure.map((item, index) => {
          if (item.url) {
            arr.push({
              url: item.url,
              name: item.name,
            })
          } else {
            if (item.length > 25) {
              arr.push({
                url: item,
                name: item.substring(item.length - 20),
              })
            } else {
              arr.push({
                url: item,
                name: item,
              })
            }
          }
        })
      }
      data.gridEnclosure = arr
      this.add = data
      this.lookxiangqing = true
    },
    //社区上报详情
    sqxiangxi: function (data) {
      let arr = []
      if (
        data.communityEnclosure != null &&
        data.communityEnclosure != undefined
      ) {
        data.communityEnclosure.map((item, index) => {
          if (item.url) {
            arr.push({
              url: item.url,
              name: item.name,
            })
          } else {
            if (item.length > 25) {
              arr.push({
                url: item,
                name: item.substring(item.length - 20),
              })
            } else {
              arr.push({
                url: item,
                name: item,
              })
            }
          }
        })
      }
      data.communityEnclosure = arr
      this.add = data
      this.sqxi = true
    },
    //关闭社区上报详情
    hidesqxiangxi: function (data) {
      this.offondialog("sqxi")
    },
    //关闭上报详情
    hidexiangxi: function (data) {
      this.offondialog("lookxiangqing")
    },
    //显示网格员上报
    myupload: async function (data) {
      let result = await this.$post("/admin/gridTask/info/gridReportList", {
        taskId: data.id,
        reportType: 1,
      })
      result.content.map((item, index) => {
        if (item.gridEnclosure != null && item.gridEnclosure != undefined) {
          let arr1 = item.gridEnclosure.split("#")
          arr1.map((item, index) => {
            if (item == "") {
              arr1.splice(index, 1)
            }
          })
          item.gridEnclosure = arr1
        }

        if (item.gridPhoto != null && item.gridPhoto != undefined) {
          let arr = item.gridPhoto.split("#")
          arr.map((item, index) => {
            if (item == "") {
              arr.splice(index, 1)
            }
          })
          item.gridPhoto = arr
        }

        item.reportFlag = item.reportFlag == 1 ? "已上报" : "未上报"
        item.readFlag = item.readFlag == 1 ? "已读" : "未读"
      })

      let mydata = []
      result.content.map((item, index) => {
        if (item.reportFlag != "未上报") {
          mydata.push(item)
        }
      })
      this.add = mydata
      this.lookupload = true
    },
    //查看社区上报
    cksqsb: async function (data) {
      let result = await this.$post("/admin/gridTask/info/gridReportList", {
        taskId: data.id,
        reportType: 2,
      })
      result.content.map((item, index) => {
        if (
          item.communityEnclosure != null &&
          item.communityEnclosure != undefined
        ) {
          let arr1 = item.communityEnclosure.split("#")
          arr1.map((item, index) => {
            if (item == "") {
              arr1.splice(index, 1)
            }
          })
          item.communityEnclosure = arr1
        }
        if (item.communityPhoto != null && item.communityPhoto != undefined) {
          let arr = item.communityPhoto.split("#")
          arr.map((item, index) => {
            if (item == "") {
              arr.splice(index, 1)
            }
          })
          item.communityPhoto = arr
        }

        item.communityReportFlag =
          item.communityReportFlag == 1 ? "已上报" : "未上报"
        item.communitySaveFlag = item.communitySaveFlag == 1 ? "已读" : "未读"
      })

      let mydata = []
      result.content.map((item, index) => {
        if (item.communityReportFlag != "未上报") {
          mydata.push(item)
        }
      })
      this.add = mydata
      this.cksqsbshow = true
    },
    //隐藏社区上报
    cksqsbhide: function () {
      this.offondialog("cksqsbshow")
    },
    //关闭网格员上报
    hideupload: function () {
      this.offondialog("lookupload")
    },
    //打开新增页面
    showa: function () {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$Bus.$emit("reset", "")
      })
    },
    //获取审核人员列表
    getReviewerList: async function () {
      let result = await this.$post("/admin/user/info/list", {
        pageNo: 1,
        pageSize: 999,
        userPosts: [5, 6, 7, 8, 9, 10, 11],
      })
      result.content.list.map((item, index) => {
        this.reviewerlist.push({
          name: item.name,
          id: item.id,
        })
      })
    },
    //显示修改模态框
    changedata: function (data) {
      this.add = data
      let obj = []
      data.receivePersons.map((item, index) => {
        obj.push({
          label: item.name,
          value: item.id,
        })
      })
      this.add.receivePersonList = obj
      // this.$nextTick(()=>{
      //      this.$Bus.$emit('reset',this.add.content)
      //  })
      this.text1 = this.add.content
      if (data.enclosure != "") {
        data.enclosure.map((item, index) => {
          this.fileList.push({
            name: item.substring(item.length - 20),
            url: item,
          })
        })
      }
      data.photo.map((item) => {
        this.fileListimg.push({
          url: item,
        })
      })

      this.changeOperation = true
    },
    //显示网格员上报界面
    report: async function (data) {
      let result = await this.$post("/admin/gridTask/info/gridManView", {
        id: data.id,
      })
      if (result.code == 200 && result.content != null) {
        if (
          result.content.gridContent != null &&
          result.content.gridContent != undefined
        ) {
          // this.$nextTick(()=>{
          //     this.$Bus.$emit('reset',result.content.gridContent)
          // })
          // setTimeout(() => {
          //     this.$Bus.$emit('reset',result.content.gridContent)
          // }, 100);
          this.text1 = result.content.gridContent
        } else {
          // this.$nextTick(()=>{
          //     this.$Bus.$emit('reset','')
          // })
          // setTimeout(() => {
          //     this.$Bus.$emit('reset','')
          // }, 100);
          this.text1 = ""
        }

        //处理附件
        if (
          result.content.gridEnclosure != null &&
          result.content.gridEnclosure != undefined
        ) {
          let arr = result.content.gridEnclosure.split("#")
          arr.map((item, index) => {
            if (item == "") {
              arr.splice(index, 1)
            } else {
              this.fileList.push({
                name: item.substring(item.length - 20),
                url: item,
              })
              this.add.enclosure.push(item)
            }
          })
        }

        //处理图片
        if (
          result.content.gridPhoto != null &&
          result.content.gridPhoto != undefined
        ) {
          let arr = result.content.gridPhoto.split("#")
          arr.map((item, index) => {
            if (item == "") {
              arr.splice(index, 1)
            } else {
              this.fileListimg.push({
                url: item,
              })
              this.add.photo.push(item)
            }
          })
        }
      }
      this.taskId = data.id
      this.lookReport = true
    },
    //显示社区上报界面
    shequreport: async function (data) {
      let result = await this.$post("/admin/gridTask/info/communityView", {
        taskId: data.id,
      })
      if (result.code == 200 && result.content != null) {
        if (
          result.content.communityContent != null &&
          result.content.communityContent != undefined
        ) {
          this.text1 = result.content.communityContent
        } else {
          this.text1 = ""
        }

        //处理附件
        if (
          result.content.communityEnclosure != null &&
          result.content.communityEnclosure != undefined
        ) {
          let arr = result.content.communityEnclosure.split("#")
          arr.map((item, index) => {
            if (item == "") {
              arr.splice(index, 1)
            } else {
              this.fileList.push({
                name: item.substring(item.length - 20),
                url: item,
              })
              this.add.enclosure.push(item)
            }
          })
        }

        //处理图片
        if (
          result.content.communityPhoto != null &&
          result.content.communityPhoto != undefined
        ) {
          let arr = result.content.communityPhoto.split("#")
          arr.map((item, index) => {
            if (item == "") {
              arr.splice(index, 1)
            } else {
              this.fileListimg.push({
                url: item,
              })
              this.add.photo.push(item)
            }
          })
        }
      } else {
        this.text1 = ""
      }
      this.taskId = data.id
      this.shequlookReport = true
    },
    //关闭社区上报界面
    shequhideReport: function () {
      this.offondialog("shequlookReport")
    },
    //关闭网格员上报界面
    hideReport: function () {
      this.offondialog("lookReport")
    },
    //网格员上报发送
    reportSend: async function (type) {
      this.add.content = this.text1
      var str = ""
      if (Array.isArray(this.add.photo)) {
        this.add.photo.map((item, index) => {
          str += item + "#"
        })
      } else {
        str = this.add.photo
      }
      this.$set(this.add, "photo", str)

      let str1 = ""
      if (
        this.add.enclosure != undefined &&
        Array.isArray(this.add.enclosure)
      ) {
        this.add.enclosure.map((item, index) => {
          str1 += item + "#"
        })
      } else {
        str = this.add.enclosure
      }
      this.add.enclosure = str1

      let reportFlag = type == 3 ? 0 : 1
      let obj = {
        id: this.taskId,
        gridPhoto: this.add.photo,
        gridEnclosure: this.add.enclosure,
        gridContent: this.add.content,
        saveFlag: reportFlag,
        reportFlag: reportFlag,
      }
      let result = await this.$post("/admin/gridTask/info/gridReport", obj)
      if (type == 1) {
        this.showMsg(result.code, "上报成功", "上报失败")
      } else {
        this.showMsg(result.code, "保存成功", "保存失败")
      }
      if (result.code == 200) {
        this.getPageDatas("", "gridTask")
        this.offondialog("lookReport")
      }
    },
    //社区上报发送
    shequreportSend: async function (type) {
      this.add.content = this.text1
      var str = ""
      if (Array.isArray(this.add.photo)) {
        this.add.photo.map((item, index) => {
          str += item + "#"
        })
      } else {
        str = this.add.photo
      }
      this.$set(this.add, "photo", str)

      let str1 = ""
      if (
        this.add.enclosure != undefined &&
        Array.isArray(this.add.enclosure)
      ) {
        this.add.enclosure.map((item, index) => {
          str1 += item + "#"
        })
      } else {
        str = this.add.enclosure
      }
      this.add.enclosure = str1

      let reportFlag = type == 3 ? 0 : 1
      let obj = {
        taskId: this.taskId,
        communityPhoto: this.add.photo,
        communityEnclosure: this.add.enclosure,
        communityContent: this.add.content,
        communitySaveFlag: type,
        communityReportFlag: reportFlag,
      }
      let result = await this.$post("/admin/gridTask/info/communityReport", obj)
      if (type == 1) {
        this.showMsg(result.code, "上报成功", "上报失败")
      } else {
        this.showMsg(result.code, "保存成功", "保存失败")
      }
      if (result.code == 200) {
        this.getPageDatas("", "gridTask")
        this.offondialog("shequlookReport")
      }
    },
    //修改页面发送
    changesend: async function () {
      //循环拼接
      var str = ""
      if (Array.isArray(this.add.photo)) {
        this.add.photo.map((item, index) => {
          str += item + "#"
        })
      } else {
        str = this.add.photo
      }
      this.$set(this.add, "photo", str)

      this.add.content = this.text1
      let str1 = ""
      if (
        this.add.receivePersonList != undefined &&
        Array.isArray(this.add.receivePersonList)
      ) {
        this.add.receivePersonList.map((item, index) => {
          if (item[0] == undefined) {
            str1 += item.value + ","
          } else {
            str1 += item.value + ","
          }
        })
      } else {
        str1 = this.add.receivePersonList
      }

      let str2 = ""
      if (
        this.add.enclosure != undefined &&
        Array.isArray(this.add.enclosure)
      ) {
        this.add.enclosure.map((item, index) => {
          str2 += item + "#"
        })
      } else {
        str2 = this.add.enclosure
      }

      this.add.receivePerson = str1
      this.add.enclosure = str2

      // if(this.add.auditFlag == "不通过"){
      //     this.add.auditFlag = 0
      // }else if(this.add.auditFlag == "通过"){
      //     this.add.auditFlag = 2
      // }else{
      //     this.add.auditFlag = 1
      // }

      this.add.reportFlag = this.add.reportFlag == "未上报" ? 0 : 1
      this.$set(this.add, "photo", str)
      this.$delete(this.add, "createDate")
      this.$set(this.add, "auditFlag", 1)
      let result = await this.$post("/admin/gridTask/info/insert", this.add)
      this.showMsg(result.code, "修改成功", "修改失败")
      if (result.code == 200) {
        this.offondialog("changeOperation")
        this.getPageDatas("", "gridTask")
      }
    },
    //关闭新增对话框
    offonNew: function (done) {
      this.offondialog()
    },
    //关闭修改对话框
    offonChange: function () {
      this.offondialog("changeOperation")
    },
    //关闭查看对话框
    offonLook: function () {
      this.offondialog("lookOperation")
    },
    //确定新增数据
    send: async function () {
      //循环拼接
      var str = ""
      if (Array.isArray(this.add.photo)) {
        this.add.photo.map((item, index) => {
          str += item + "#"
        })
      } else {
        str = this.add.photo
      }

      this.$set(this.add, "photo", str)
      let str1 = ""
      if (
        this.add.receivePersonList != undefined &&
        Array.isArray(this.add.receivePersonList)
      ) {
        this.add.receivePersonList.map((item, index) => {
          str1 += item.value + ","
        })
      } else {
        str1 = this.add.receivePersonList
      }

      let str2 = ""
      if (
        this.add.enclosure != undefined &&
        Array.isArray(this.add.enclosure)
      ) {
        this.add.enclosure.map((item, index) => {
          str2 += item + "#"
        })
      } else {
        str2 = this.add.enclosure
      }
      this.add.receivePerson = str1
      this.add.enclosure = str2
      this.add.content = this.text1
      this.add.bigType = this.bigType
      this.add.smallType = this.smallType
      let result = await this.$post("/admin/gridTask/info/insert", this.add)
      this.showMsg(result.code, "新增成功", "新增失败")
      if (result.code == 200) {
        this.getPageDatas("", "gridTask")
      }
      console.log(this.add)
    },
    //展示消息提示
    showMsg: function (code, success, error) {
      if (code == 200) {
        this.$message({
          message: success,
          type: "success",
        })
        this.offondialog()
      } else {
        this.$message({
          message: error,
          type: "error",
        })
      }
    },
    //关闭增加,查看,修改等界面
    offondialog: function (type = "dialogVisible") {
      // 任务类别子类置空
      this.samllTaskCategory = []
      // 大类选中项清空
      this.bigType = ""
      // 子类选中项清空
      this.smallType = ""
      this[type] = false
      this.userlist = []
      this.fileListimg = []
      this.fileList = []
      this.myfilelist = []
      this.receivePerson = []
      this.text1 = ""
      this.value = ""
      this.taskId = null
      this.add = {
        taskName: "", //任务名称
        completeTime: "", //完成时间
        receivePersonList: [], //接收人员
        auditPersonId: "", //审核人员
        content: "", //指派内容
        enclosure: [], //附件后台返回的地址
        photo: [], //图片后台返回的地址
      }
      this.$forceUpdate()
    },
    //删除方法
    deletepanduan: async function (data) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let result = await this.$post("/admin/gridTask/info/delete", {
          id: data.id,
        })
        this.showMsg(result.code, "删除成功", "删除失败")
        if (result.code == 200) {
          this.getPageDatas("", "gridTask")
        }
      })
    },
    //查看和审核方法
    look: async function (data, type) {
      this.lookTitle = type
      this.add = data
      if (data.enclosure != "") {
        data.enclosure.map((item, index) => {
          this.myfilelist.push({
            name: item.substring(item.length - 20),
            url: item,
          })
        })
      }
      if (type == "审核") {
        this.isaudit = true
      } else if (type == "查看") {
        this.isaudit = false
      }
      //上传的数据
      if (this.orgLevel == 4) {
        let result = await this.$post("/admin/gridTask/info/gridManView", {
          id: data.id,
        })
        if (result.content.saveFlag == 1) {
          this.add.gridContent = result.content.gridContent
          this.$set(this.add, "gridEnclosure", [])
          this.$set(this.add, "gridPhoto", [])
          //处理附件
          if (
            result.content.gridEnclosure != null &&
            result.content.gridEnclosure != undefined
          ) {
            let arr = result.content.gridEnclosure.split("#")
            console.log(arr)
            arr.map((item, index) => {
              if (item == "") {
                arr.splice(index, 1)
              } else {
                this.add.gridEnclosure.push({
                  name: item.substring(item.length - 20),
                  url: item,
                })
              }
            })
            console.log(this.add.gridEnclosure)
          }

          //处理图片
          if (
            result.content.gridPhoto != null &&
            result.content.gridPhoto != undefined
          ) {
            let arr = result.content.gridPhoto.split("#")
            arr.map((item, index) => {
              if (item == "") {
                arr.splice(index, 1)
              } else {
                this.add.gridPhoto.push(item)
              }
            })
          }
          this.lookshow = true
        } else {
          this.lookshow = false
        }
      }
      this.lookOperation = true
    },
    // 审核是否通过
    audit: async function (type) {
      this.isClick = true
      let id = this.add.id
      if (type == 0 && this.AuditOpinion == "") {
        this.$message.success("请填写审批不通过的原因")
        return
      }
      if (type == 0) {
        //审核不通过
        let result = await this.$http.post("/admin/gridTask/info/audit", {
          id: id,
          auditFlag: type,
          failureReason: this.AuditOpinion,
        })
        if (result.code !== 200) {
          this.$message.error("审批数据失败")
        }
        this.$message.success("审批数据成功")
        this.init()
        this.offondialog("lookOperation")
        this.isClick = true
      } else {
        let result = await this.$http.post("/admin/gridTask/info/audit", {
          id: id,
          auditFlag: type,
        })
        if (result.code !== 200) {
          this.$message.error("审批数据失败")
        }
        this.$message.success("审批数据成功")
        this.init()
        this.offondialog("lookOperation")
      }
      setTimeout(() => {
        this.isClick = false
      }, 500)
    },
    //上传文件方法
    handleRemove(file, fileList) {
      this.add.enclosure.map((item, index) => {
        if (file.response != undefined) {
          if (item == file.response.content) {
            this.add.enclosure.splice(index, 1)
          }
        } else {
          if (item == file.url) {
            this.add.enclosure.splice(index, 1)
          }
        }
      })
    },
    handlePreview(file) {
      console.log(file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    fileok: function (data) {
      if (data.code == 200) {
        this.add.enclosure.push(data.content)
      }
    },

    //上传图片方法
    handleRemove2(file, fileList) {
      this.add.photo.map((item, index) => {
        if (file.response != undefined) {
          if (item == file.response.content) {
            this.add.photo.splice(index, 1)
          }
        } else {
          if (item == file.url) {
            this.add.photo.splice(index, 1)
          }
        }
      })
    },
    handlePictureCardPreview2(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible1 = true
    },
    imgok: function (data, data1, data2) {
      if (data.code == 200) {
        this.add.photo.push(data.content)
      }
    },
    //指派人员方法
    async handleChange(value) {
      let arr = []
      value.map((item, index) => {
        if (item.length > 1) {
          arr.push(item[item.length - 1])
        }
      })
      let result = await post("admin/user/info/findUserByOrgIds", {
        orgIds: arr,
        pageNo: 1,
        pageSize: 9999,
        userPosts: [1, 2, 12, 14],
      })
      let obj = []
      result.content.list.map((item, index) => {
        obj.push({
          label: item.name,
          value: item.id,
        })
      })
      this.userlist = obj
      this.userlist.unshift({
        label: "全部选择",
        value: 0,
      })
    },
    //添加接收人员
    receiveChange: function (data) {
      console.log(data)
      // 如果全部选中
      if (data[0] === 0) {
        this.add.receivePersonList = []
        this.userlist.forEach((item) => {
          if (item.value !== 0) {
            this.add.receivePersonList.push(item)
          }
        })
        this.$forceUpdate()
        return
      }
      let obj = null
      this.userlist.map((item, index) => {
        if (item.value == data[0]) {
          obj = item
        }
      })
      if (obj != null && this.add.receivePersonList.length) {
        let bool = this.add.receivePersonList.every(function (item) {
          return item.value != obj.value
        })
        if (bool) {
          this.add.receivePersonList.push(obj)
        }
      } else {
        this.add.receivePersonList.push(obj)
      }
      this.$forceUpdate()
    },
    //删除已选接收人员
    deleteReceive: function (data) {
      this.$confirm("此操作将删除该人员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.add.receivePersonList.map((item, index) => {
          if (item.value == data.value) {
            this.add.receivePersonList.splice(index, 1)
            this.$forceUpdate()
          }
        })
      })
    },

    //催办分页
    changepageSize: function (data) {
      this.mypageConfig.pageNo = data
      this.getCbList()
    },

    // 根据审核状态切换表格样式
    tableRowClassName({ row, rowIndex }) {
      // 进度比较
      if (row.taskProgress) {
        const speed = row.taskProgress.split("/")
        if (speed[0] !== speed[1]) {
          return "warning-row"
        }
      }
    },
    // 任务类别大类改变
    onBigTypeChange() {
      // 任务类别子类清空
      this.samllTaskCategory = []
      // 子类选中项清空
      this.smallType = ""
      console.log(this.bigType)
      let dictType = ""
      switch (this.bigType) {
        case 1:
          dictType = "grid_task_comprehensive coordination"
          break
        case 2:
          dictType = "grid_task_social_governance"
          break
        case 3:
          dictType = "grid_task_social_affairs"
          break
        case 4:
          dictType = "grid_task_city_management"
          break
      }
      // dictCode: 109
      // dictSort: 0
      // dictLabel: "党的建设"
      // dictValue: "109"
      this.getDicts(dictType).then((res) => {
        res.data.forEach((item) => {
          const obj = {
            value: item.dictCode,
            label: item.dictLabel,
          }
          this.samllTaskCategory.push(obj)
        })
      })
    },
    // 搜索列表任务类别大类改变
    onSearchBigTypeChange() {
      // 任务类别子类清空
      this.searchSamllTaskCategory = []
      // 子类选中项清空
      this.searchlist.smallType = ""
      let dictType = ""
      switch (this.searchlist.bigType) {
        case 1:
          dictType = "grid_task_comprehensive coordination"
          break
        case 2:
          dictType = "grid_task_social_governance"
          break
        case 3:
          dictType = "grid_task_social_affairs"
          break
        case 4:
          dictType = "grid_task_city_management"
          break
      }
      // dictCode: 109
      // dictSort: 0
      // dictLabel: "党的建设"
      // dictValue: "109"
      this.getDicts(dictType).then((res) => {
        res.data.forEach((item) => {
          const obj = {
            value: item.dictCode,
            label: item.dictLabel,
          }
          this.searchSamllTaskCategory.push(obj)
        })
      })
    },
    // 触发数据响应式
    onSearchSmallTypeChange(val) {
      this.$set(this.searchlist, this.searchlist.smallType, val)
    },
  },
  watch: {
    // 选择部门选择后就关闭弹窗
    receivePerson() {
      // if(this.$refs.receivePerson){
      //     this.$refs.receivePerson.dropDownVisible = false; //监听值发生变化就关闭它
      // }
    },
  },
  created() {
    this.searchlist = {
      approvalOrgId: "",
    }
  },
}
</script>
<style scope>
.gridClickButton span {
  margin-right: 0px !important;
  text-align: center !important;
}
.gridTimeSelector {
  width: 180px !important;
  /* padding: 0 0 0 20px!important; */
  cursor: pointer !important;
}
.gridTimeSelector > input {
  display: inline-block !important;
  cursor: pointer !important;
}
.gridTimeSelector span {
  width: auto !important;
  text-align: left !important;
  display: block !important;
  margin-top: 0px !important;
  cursor: pointer !important;
}
</style>

<style lang="less" scoped>
.top {
  margin: 12px;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.button {
  margin-bottom: 4px;
}
.add {
  position: relative;
  margin-top: 20px;
  span {
    width: 100px;
    display: inline-block;
    text-align: right;
    margin-right: 20px;
  }
  .zujian {
    width: 300px;
    display: inline-block;
  }
  .width {
    width: 70%;
  }
  .textarea {
    width: 300px;
  }

  .lookimg {
    width: 150px;
    height: 150px;
    border-radius: 4px;
    display: inline-block;
    margin: 0 10px 10px 0;
  }
}
.jieshou {
  border: 1px solid #ccc;
  min-height: 100px;
  cursor: pointer;
  .yixuan {
    display: inline-block;
    margin: 4px;
    border: 1px solid #ccc;
    padding: 0 4px;
    border-radius: 4px;
    transition: 0.3s;
    span {
      width: auto;
      display: inline-block;
      margin-right: 6px;
    }
    i {
      font-weight: 600;
    }
    &:hover i {
      color: red;
    }
    &:hover {
      background-color: skyblue;
    }
  }
}
.auto {
  display: inline-block;
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: none;
  color: skyblue;
  vertical-align: -3px;
}
.hover {
  position: relative;
  display: inline-block;
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    z-index: 9;
    content: "";
    opacity: 0;
    width: 150px;
    height: 150px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: 0.3s;
  }
  i {
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    opacity: 0;
    width: 26px;
    height: 26px;
    font-size: 26px;
    transition: 0.3s;
  }
  &:hover:after {
    opacity: 1;
    border-radius: 4px;
  }
  &:hover i {
    opacity: 1;
  }
}
.delete {
  animation: delete 1s;
  animation-fill-mode: forwards;
}
@keyframes delete {
  0% {
    transform: translateY(0px);
    opacity: 1;
  }
  50% {
    transform: translateY(-15px);
    opacity: 0.5;
  }
  100% {
    transform: translateY(-30px);
    opacity: 0;
  }
}
.bottombutton {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.bigbox {
  position: fixed;
  z-index: 99999999999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .bigImg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    max-width: 80%;
    max-height: 90%;
  }
}
.cboffon {
  display: flex;
  margin-top: -20px;
  margin-bottom: 20px;
  p {
    width: 80px;
    margin-right: 20px;
    text-align: center;
    line-height: 30px;
    border-radius: 4px;
    cursor: pointer;
  }
  .show {
    background-color: #01aaef;
    color: #fff;
  }
  .hide {
    background-color: #fff;
  }
}
.position {
  position: absolute;
  top: 0;
}
.el-table .warning-row {
  background: #e6f4fd !important;
}

.el-table .success-row {
  background: #f0f9eb;
}
.task-category {
  width: 420px !important;
  display: flex;
  justify-content: center;
  .task-category-left,
  .task-category-right {
    width: 150px !important;
  }
  .task-category-right {
    margin-left: 10px !important;
  }
}
.completeTime {
  width: 250px !important;
}
.createPersonName {
  width: 140px !important;
}
.bigType,
.smallType {
  width: 112px !important;
}
</style>
